<template>
  <div class="audience-select-view">
    <div class="select-view-title">{{ $t('audience.select_view.title') }}</div>

    <div class="select-view-controls">
      <div class="select-view select-view-summary"
        @click="$emit('change', 'summary')"
        :class="{ 'is-active': view === 'summary' }">
        <span></span><span></span>
      </div>
      
      <div class="select-view select-view-detail"
        @click="$emit('change', 'detail')"
        :class="{ 'is-active': view === 'detail' }">
        <span></span><span></span><span></span><span></span><span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    view: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.audience-select-view {
  display: flex;
  height: 2.5rem;
  // border-left: 1px solid rgba($white, .16);
  border-left: 1px solid rgba($black, .08);
  border-right: 1px solid rgba($black, .08);
  padding: .6875rem 1.125rem;
}

.select-view-title {
  font-size: .6875rem;
  font-weight: $weight-medium;
  // color: rgba($white, .64);
  color: rgba($black, .64);
  letter-spacing: 2.3px;
  text-transform: uppercase;
}

.select-view-controls {
  display: flex;
  margin-left: 1rem;
}

.select-view {
  position: relative;
  display: inline-flex;
  justify-content: center;
  width: 1.5rem;
  padding: .125rem 0;
  cursor: pointer;

  & + .select-view {
    margin-left: 1.25rem;
  }

  &.is-active {
    cursor: default;

    span {
      // border-color: $primary;
      border-color: $black;
    }
  }

  &:not(.is-active) {
    &:hover {
      span {
        // border: 1px solid rgba($white, .87);
        border-color: rgba($black, .87);
      }
    }
  }

  span {
    border-radius: 1px;
    // border: 1px solid rgba($white, .56);
    border: 1px solid rgba($black, .4);
    transition: $transition;
  }
}

.select-view-summary {
  span {
    width: .5rem;

    &:nth-child(2) {
      margin-left: 2px;
    }
  }
}

.select-view-detail {
  span {
    &:nth-child(-n+4) {
      position: absolute;
      width: .375rem;
      height: .375rem;
    }

    &:nth-child(1) {
      top: .125rem;
      left: 0;
    }

    &:nth-child(2) {
      top: .125rem;
      right: 0;
    }

    &:nth-child(3) {
      bottom: .125rem;
      right: 0;
    }

    &:nth-child(4) {
      bottom: .125rem;
      left: 0;
    }

    &:nth-child(5) {
      width: .375rem;
    }
  }
}
</style>

